import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Indian() {
  return (
    <ApiCommunityDirectoryPage
      community="Indian"
      eyebrow="Indian community guide"
      title="Indian favorites, businesses, and local essentials in San Antonio."
      
      tags={["Indian community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Indian community guide?"
      modalIdPrefix="indian-directory"
    />
  );
}
